import gql from 'graphql-tag'

export const CONVERT_USER_TO_CONTACT = gql`
    mutation ($input: ConvertUserToContactInput!) {
        convertUserToContact(input: $input) {
            id
            name
            lastName
            motherLastName
            email
            phone
            status
            area
            groups {
                id
                name
                platform
                type
                isWhatsapp
                numberEvents
            }
        }
    }
`
